import React, { FC } from 'react';
import { SelectArrayInput, useTranslate } from 'react-admin';
import { useHandbooksQuery } from '~/hooks/useHandbook';
import { useApiLocalization } from '~/hooks/useApiLocalization';
import { useTenant } from '~/hooks/tenant';
import { l } from '~/utils/solutions';

interface DebitOrderFormProps {
  keyName: string;
}

export const DebitOrderForm: FC<DebitOrderFormProps> = ({ keyName }) => {
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));

  const { data: tenant } = useTenant();
  const { data: handbook } = useHandbooksQuery(tenant?.id);
  const subtypes = (handbook?.operationSubtypes || [])
    .filter((subtype) => subtype.operationType === 'DEBIT_ORDER')
    .map((subtype) => subtype.operationSubtype);

  const { data: subtypeTranslations } = useApiLocalization('operationSubtype', subtypes.length > 0);

  const subtypeChoices = subtypes.map((subtype) => ({
    id: subtype,
    name: subtypeTranslations?.[`operationSubtype.${subtype}`] || subtype,
  }));

  return (
    <SelectArrayInput
      label={t('debitOrderBlockedSenderExemptSubtypes')}
      source={`${keyName}.blockedSenderExemptSubtypes`}
      choices={subtypeChoices}
      style={{ width: 600 }}
    />
  );
};
